import React, { useState } from "react";

const VARIANTS = {
  yellow:  { from: "#EAB308", to: "#CA8A04", hoverFrom: "#CA8A04", hoverTo: "#A16207" },
  blue:    { from: "#3B82F6", to: "#2563EB", hoverFrom: "#2563EB", hoverTo: "#1D4ED8" },
  green:   { from: "#22C55E", to: "#16A34A", hoverFrom: "#16A34A", hoverTo: "#15803D" },
  emerald: { from: "#10B981", to: "#0D9488", hoverFrom: "#059669", hoverTo: "#0F766E" },
  red:     { from: "#EF4444", to: "#DC2626", hoverFrom: "#DC2626", hoverTo: "#B91C1C" },
  purple:  { from: "#A855F7", to: "#9333EA", hoverFrom: "#9333EA", hoverTo: "#7E22CE" },
  outline: { outline: true },
  danger:  { from: "#EF4444", to: "#DC2626", hoverFrom: "#DC2626", hoverTo: "#B91C1C" },
};

const buildBackground = (cfg, hovered) => {
  if (cfg.outline) return "white";
  const from = hovered ? cfg.hoverFrom : cfg.from;
  const to = hovered ? cfg.hoverTo : cfg.to;
  return `linear-gradient(to right, ${from}, ${to})`;
};

export default function ButtonEnhanced({
  onClick,
  children,
  variant = "yellow",
  icon,
  disabled = false,
  style: extraStyle = {},
  type = "button",
}) {
  const [hovered, setHovered] = useState(false);
  const cfg = VARIANTS[variant] || VARIANTS.yellow;
  const isOutline = !!cfg.outline;

  const baseStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "8px 16px",
    fontWeight: 500,
    fontSize: 14,
    borderRadius: 8,
    border: isOutline ? "2px solid #D1D5DB" : "none",
    color: isOutline ? "#374151" : "white",
    background: isOutline
      ? hovered ? "#F9FAFB" : "white"
      : buildBackground(cfg, hovered && !disabled),
    boxShadow: hovered && !disabled
      ? "0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -2px rgba(0,0,0,0.1)"
      : "0 1px 2px 0 rgba(0,0,0,0.05), 0 1px 3px 0 rgba(0,0,0,0.1)",
    transition: "all 0.2s ease",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.5 : 1,
    ...extraStyle,
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={baseStyle}
    >
      {icon && <span style={{ marginRight: 8, display: "inline-flex" }}>{icon}</span>}
      {children}
    </button>
  );
}
